import * as React from 'react'
import './Works.css'
import Card from '../Card/Card'
import { Link } from 'gatsby'

const Works = ({ gridNumber, gridSize, projectsArray, cardWidth, minHeight, allprojects = false }) => {
  const animation = allprojects
    ? { 'data-sal': 'slide-up', 'data-sal-delay': '900', 'data-sal-easing': 'ease-in-out', 'data-sal-duration': '900' }
    : {}

  return (
    <section id='works' className='s-works'>
      <div
        className='intro-wrap'
        data-sal='slide-right'
        data-sal-delay='100'
        data-sal-duration='300'
        data-sal-easing='ease-in-out'
      >
        <div className='row section-header has-bottom-sep light-sep'>
          <div className='col-full text-center'>
            <h3 className='subhead'>{allprojects ? 'Works' : 'Recent Works'}</h3>
            <h1 className='display-2 display-2--light'>
              {allprojects ? 'All my Projects' : "The projects I'm most proud of, check out some of them"}
            </h1>
          </div>
        </div>
      </div>

      <div className={`row works-content ${gridSize} block-tab-full`} {...animation} style={{ minHeight: '1vh' }}>
        {projectsArray.map((project, i) => (
          <Card
            {...project}
            key={project.id}
            cardWidth={cardWidth}
            minHeight={minHeight}
            noAnimation={allprojects}
            animation={allprojects ? 'zoom-in' : i % gridNumber === 1 ? 'slide-left' : 'slide-right'}
          />
        ))}
      </div>

      {!allprojects && (
        <div className='row'>
          <div className='col-twelve text-center'>
            <Link to='/projects' className=' btn btn--stroke add-top text-center alt-btn-color'>
              All my Projects
            </Link>
          </div>
        </div>
      )}
    </section>
  )
}

export default Works
